module.exports = __webpack_public_path__ + "static/video1-c99f06f795600751837153260bd40d24.png";